import { render, staticRenderFns } from "./RoleBreadcrumb.vue?vue&type=template&id=061dde34&scoped=true&"
import script from "./RoleBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./RoleBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./RoleBreadcrumb.vue?vue&type=style&index=0&id=061dde34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061dde34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('061dde34')) {
      api.createRecord('061dde34', component.options)
    } else {
      api.reload('061dde34', component.options)
    }
    module.hot.accept("./RoleBreadcrumb.vue?vue&type=template&id=061dde34&scoped=true&", function () {
      api.rerender('061dde34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/permissions/RoleBreadcrumb.vue"
export default component.exports